export default __webpack_public_path__ + "static/media/01.33faefe9.png";